<div>
  @if(!showInvite) {
  @if(image){<img class="img" src="{{image}}" />}
  <div class="information-screen-wrapper">
    <h4>{{title}}</h4>
    <p>{{primaryContent}}</p>
    <p>
      @if(secondaryContentHtml) {
      <span [innerHTML]="secondaryContentHtml"></span>
      }
      @else {
      {{secondaryContent}}
      }
    </p>
    <div class="link" (click)="actionClickEmit()">{{ actionContent }}</div>
  </div>
  <div class="info-screen-content">
    <ng-content></ng-content>
  </div>
  }
  @else {
  <app-card>
    @if(image){<img class="img" src="{{image}}" />}
    <div>
      <h4>{{title}}</h4>
      <p>{{primaryContent}}</p>
      <p>
        @if(secondaryContentHtml) {
        <span [innerHTML]="secondaryContentHtml"></span>
        }
        @else {
        {{secondaryContent}}
        }
      </p>
    </div>
    <div class="info-screen-content">
      <ng-content></ng-content>
    </div>
  </app-card>
    }

  @if(showInvite) {
  <app-invite-friend-screen [showInvite]="showInvite" [discounts]="discounts" expandWidth="true"></app-invite-friend-screen>
  }
</div>
